import {Injectable} from '@angular/core';
import {IResourceMethod, Resource, ResourceAction, ResourceHandler, ResourceParams, ResourceRequestMethod} from '@ngx-resource/core';
import {ResourceAuth} from '../../common.module/auth/authenticate.resource';
import {AuthServerProvider} from '../../common.module/auth/auth-jwt.service'
import {ConfiguracionTarjetaModel} from './configuracion-tarjeta.model';
import { ConfiguracionTarjetaTpvModel } from './configuracion-tarjeta-tpv.model';

@Injectable()
@ResourceParams({
  pathPrefix: '/configuracion'
  // url: 'http://localhost:8003'
})
export class ConfiguracionTarjetaResource extends ResourceAuth {
  constructor(resourceHandler: ResourceHandler, authProv: AuthServerProvider) {
    super(resourceHandler, authProv);
  }

// export class ConfiguracionTarjetaResource extends Resource {
//   constructor(resourceHandler: ResourceHandler) {
//   super(resourceHandler);
//   }

  @ResourceAction({
    path: '/configuracion-tarjeta-tia',
    method: ResourceRequestMethod.Patch
  })
  actualizarConfiguracionTarjetaTia: IResourceMethod<ConfiguracionTarjetaModel, any>;

  @ResourceAction({
    path: '/na/configuracion-tarjeta-tia',
    method: ResourceRequestMethod.Get

  })
  obtenerConfiguracionTarjetaTia: IResourceMethod<any, ConfiguracionTarjetaModel>;


  /* TARJETAS TPV */
  @ResourceAction({
    path: '/na/configuracion-tarjeta-tpv',
    method: ResourceRequestMethod.Get

  })
  obtenerConfiguracionTarjetaTpv: IResourceMethod<any, ConfiguracionTarjetaTpvModel>;

  @ResourceAction({
    path: '/configuracion-tarjeta-tpv',
    method: ResourceRequestMethod.Patch
  })
  actualizarConfiguracionTarjetaTpv: IResourceMethod<ConfiguracionTarjetaTpvModel, any>;


}
